import {
  Box,
  Tabs,
  Tab,
  Typography,
  Chip,
  Avatar,
  MenuItem,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import emptyCart from "../../../assets/Icons/empty_cart.svg";
import { Link } from "react-router-dom";
import ProductOrder from "./ProductOrder";
import ServiceOrder from "./ServiceOrder";


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 0, bgcolor: "#F8F7F7" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const OrderList = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
  
        <Box sx={{ bgcolor: "#fff", p: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="fullWidth"
            >
              <Tab
                label="Product"
                sx={{ fontFamily: "IBM Plex Sans", width:'50%' }}
                {...a11yProps(0)}
              />
              <Tab label="Service" {...a11yProps(1)} sx={{width:'50%'}} />
            </Tabs>
          </Box>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <ProductOrder />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ServiceOrder />
        </CustomTabPanel>

    </>
  );
};

export default OrderList;

const data = [1, 2, 3, 4];


